module.exports = __webpack_public_path__ + "img/field-image-uc.2c2f9d06.png";